import "./NX5_MonitorVitalData.scss";
import { MONITOR_PARAMETER } from "../../common/constant/common-constants";
import monitorOfflineIcon from "../../common/icons/svg/patient-monitor-offline.svg";
import pacemakerImage from "../../common/images/Pacemaker.png";
import alarmMuteImage from "../../common/images/alarm_mute.png";
import DevicesTab from "../../container/PatientRightPanel/MachineTabs/DevicesTab.jsx";
import MonitorChart from "../MonitorChart/MonitorChart";


const NX5_MonitorVitalDataDesktopView = ({ props }) => {

    if (props?.monitorHeartBeatData?.isConnected) {
        return (
            <div className="vitals-container">
                <div className="graph-data">
                    <div className="all-graph">
                        <div className="PM-Alarms">
                            <DevicesTab
                                activeVitalDevice={props.activeVitalDevice}
                                bedId={props.bedId}
                                alarmData={props.alarmData}
                                handleSeeAllAlarms={props.handleSeeAllAlarms}
                            />
                        </div>
                        <MonitorChart bedId={props.bedId} />
                    </div>

                    <div className="all-values">
                        <div className="HR">
                            <div className="left">
                                <div className="top-bar">
                                    <div className="label">HR</div>
                                    <img className="pacemaker" src={pacemakerImage} alt="Pacemaker" />
                                    {
                                        props.vitalData_ECG?.[MONITOR_PARAMETER.HR]?.alarm_enable === false
                                            ? <img className="alarm-mute" src={alarmMuteImage} alt="Alarm-Mute" />
                                            : null
                                    }
                                </div>
                                <div className="unit">(beats/min)</div>
                            </div>
                            <div className="middle">
                                <div className="value">
                                    {props.vitalData_ECG?.[MONITOR_PARAMETER.HR]?.value ?? "-"}
                                </div>
                            </div>
                            <div className="right">
                                <div className="limits">
                                    <span className="high">{props.vitalData_ECG?.[MONITOR_PARAMETER.HR]?.alarm_limit[1] ?? "-"}</span>
                                    <span className="low">{props.vitalData_ECG?.[MONITOR_PARAMETER.HR]?.alarm_limit[0] ?? "-"}</span>
                                </div>
                            </div>
                        </div>
                        <div className="PR">
                            <div className="left">
                                <div className="info">
                                    <div className="top-bar">
                                        <div className="label">PR</div>
                                        {
                                            props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PULSE_RATE]?.alarm_enable === false
                                                ? <img className="alarm-mute" src={alarmMuteImage} alt="Alarm-Mute" />
                                                : null
                                        }
                                    </div>
                                    <div className="unit">(beats/min)</div>
                                </div>
                                <div className="source">SOURCE:SPO2</div>
                            </div>
                            <div className="middle">
                                <div className="value">
                                    {props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PULSE_RATE]?.value ?? "-"}
                                </div>
                            </div>
                            <div className="right">
                                <div className="limits">
                                    <span className="high">{props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PULSE_RATE]?.alarm_limit[1] ?? "-"}</span>
                                    <span className="low">{props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PULSE_RATE]?.alarm_limit[0] ?? "-"}</span>
                                </div>
                            </div>
                        </div>
                        <div className="RR">
                            <div className="left">
                                <div className="info">
                                    <div className="top-bar">
                                        <div className="label">RR</div>
                                        {
                                            props.vitalData_ECG?.[MONITOR_PARAMETER.RR]?.alarm_enable === false
                                                ? <img className="alarm-mute" src={alarmMuteImage} alt="Alarm-Mute" />
                                                : null
                                        }
                                    </div>
                                    <div className="unit">(b/min)</div>
                                </div>
                                <div className="source">SOURCE:ECG</div>
                            </div>
                            <div className="middle">
                                <div className="value">
                                    {props.vitalData_ECG?.[MONITOR_PARAMETER.RR]?.value ?? "-"}
                                </div>
                            </div>
                            <div className="right">
                                <div className="limits">
                                    <span className="high">{props.vitalData_ECG?.[MONITOR_PARAMETER.RR]?.alarm_limit[1] ?? "-"}</span>
                                    <span className="low">{props.vitalData_ECG?.[MONITOR_PARAMETER.RR]?.alarm_limit[0] ?? "-"}</span>
                                </div>
                            </div>
                        </div>
                        <div className="SPO2">
                            <div className="left">
                                <div className="info">
                                    <div className="top-bar">
                                        <div className="label">SPO2</div>
                                        {
                                            props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2]?.alarm_enable === false
                                                ? <img className="alarm-mute" src={alarmMuteImage} alt="Alarm-Mute" />
                                                : null
                                        }
                                    </div>
                                    <div className="unit">(%)</div>
                                </div>
                                <div className="source">
                                    <div className="source-1">
                                        <div className="PI">PI</div>
                                        <div className="PI_unit">(%)</div>
                                    </div>
                                    <div className="source-2">{props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PERFUSION_INDEX]?.value
                                        ? props.vitalData_SPO2[MONITOR_PARAMETER.SPO2_PERFUSION_INDEX].value.toFixed(2)
                                        : "-"}
                                    </div>
                                </div>
                            </div>
                            <div className="middle">
                                <div className="value">
                                    {props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2]?.value ?? "-"}
                                </div>
                            </div>
                            <div className="right">
                                <div className="limits">
                                    <span className="high">{props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2]?.alarm_limit[1] ?? "-"}</span>
                                    <span className="low">{props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2]?.alarm_limit[0] ?? "-"}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-wrap">
                    <div className="temp">
                        <div className="left">
                            <div className="temp-heading">
                                <div className="temp-name">TEMP</div>
                                <div className="temp-unit">(°c)</div>
                            </div>

                            <div className="temp-values">
                                <div className="temp-value-1">{props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_1]?.alarm_limit[1]
                                    ? props.vitalData_TEMP[MONITOR_PARAMETER.TEMPERATURE_1].alarm_limit[1].toFixed(1)
                                    : "-"}</div>
                                <div className="temp-value-2">{props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_1]?.alarm_limit[0]
                                    ? props.vitalData_TEMP[MONITOR_PARAMETER.TEMPERATURE_1].alarm_limit[0].toFixed(1)
                                    : "-"}</div>
                            </div>
                        </div>
                        <div className="middle">
                            <div className="T1">
                                <div className="T1-name">T1</div>
                                <div className="T1-value">
                                    {props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_1]?.value
                                        ? props.vitalData_TEMP[MONITOR_PARAMETER.TEMPERATURE_1].value.toFixed(1)
                                        : "-"}
                                </div>
                            </div>
                            <div className="TD">
                                <div className="TD-name">TD</div>
                                <div className="TD-value">
                                    ({(props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_DIFF]?.value
                                        ? props.vitalData_TEMP[MONITOR_PARAMETER.TEMPERATURE_DIFF].value.toFixed(1)
                                        : "-")})
                                </div>
                            </div>
                        </div>
                        <div className="right">
                            <div className="T2">
                                <div className="T2-name">T2</div>
                                <div className="T2-value">
                                    {props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_2]?.value
                                        ? props.vitalData_TEMP[MONITOR_PARAMETER.TEMPERATURE_2].value.toFixed(1)
                                        : "-"}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="nibp">
                        <div className="left">
                            <div className="nibp-data">
                                <div className="nibp-heading">
                                    <div className="nibp-name">NIBP</div>
                                    <div className="nibp-unit">(mmHg)</div>
                                </div>

                                <div className="nibp-values">
                                    <div className="nibp-value-1">{props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_SYSTOLIC]?.alarm_limit[1] ?? "-"}</div>
                                    <div className="nibp-value-2">{props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_SYSTOLIC]?.alarm_limit[0] ?? "-"}</div>
                                </div>
                            </div>
                        </div>
                        <div className="right">
                            <div className="nibp-value-3">
                                {`${props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_SYSTOLIC]?.value ?? "-"}/${props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_DIASTOLIC]?.value ?? "-"}`}
                            </div>
                            <div className="nibp-value-4">({props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_MEAN]?.value ?? "-"})</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className='offline'>
                <img className='monitor-offline' src={monitorOfflineIcon} alt="Monitor Offline" />
                <h2 className='not-in-use-text'>Monitor is currently offline, possibly due to settings or poor internet connection; please check and ensure proper configuration for seamless monitoring.</h2>
            </div>
        );
    }
};

export default NX5_MonitorVitalDataDesktopView;
